import {Controller} from "stimulus"
import $ from 'jquery';
import {set_locale} from './localize_controller'
import Swal from 'sweetalert2/dist/sweetalert2'
window.Swal = Swal

let social_icon_object = {
   'facebook': 'icon-social-facebook',
    'whatsapp': 'fab fa-whatsapp',
    'twitter':'icon-social-twitter',
    'youtube':'icon-social-youtube',
    'instagram':'icon-social-instagram',
    'official' : 'icon-globe',
    'telegram' : 'fab fa-telegram-plane'
}

function tpl_social_button(type, url) {
    return `
     <a href="${url}" target="_blank" class="footer-social-link">
          <span class="${social_icon_object[type]}" title="${type}"></span>
        </a>
    `;
}

function btn_float(type, url) {
    let btn_float_html = $(`#btn-float-${type}`);
    if (btn_float_html.length > 0) {
        btn_float_html.attr('href', url);
    }
}

export default class extends Controller {

    connect() {
        set_locale().then(
            locale => {
                $.ajax({
                    url: `/${locale.locale}/preferences/to/social.json`,
                    data: {},
                    type: 'GET',
                    success: function (data) {
                        let social_area = $('.social-links');
                        let html = '';
                        data.map( element => {
                            html+= tpl_social_button(element.key.text,element.value);
                            btn_float(element.key.text,element.value)
                        })
                        social_area.map(area => {
                            social_area[area].innerHTML = html;
                        })



                    }
                })
            }
        )

        // Inicializar el interceptor de enlaces externos
        this.confirmExternalLinks();
    }

    // Intercepta clicks en enlaces sociales (dinámicos y del partial) y muestra confirmación si la URL es externa
    confirmExternalLinks() {
        document.addEventListener('click', (e) => {
            const anchor = e.target.closest('a.footer-social-link, a.social-icon, a[id^="btn-float-"], a[id^="to_section_"]');
            if (!anchor) return;
            if (e.defaultPrevented) return;

            const href = anchor.getAttribute('href');
            if (!href) return;

            // Ignorar enlaces con href vacío, anclas o javascript:
            if (href.startsWith('#') || href.startsWith('javascript:')) return;

            let url;
            try {
                url = new URL(href, location.origin);
            } catch (err) {
                return;
            }

            if (url.origin !== location.origin) {
                e.preventDefault();
                e.stopPropagation();

                const message = 'Va a salir del sitio. ¿Desea continuar hacia: ' + url.href + '?';
                const target = anchor.getAttribute('target') || '_self';

                if (window.bootbox && typeof bootbox.confirm === 'function') {
                    bootbox.confirm({
                        message: message,
                        buttons: {
                            confirm: { label: 'Continuar', className: 'btn-primary' },
                            cancel: { label: 'Cancelar', className: 'btn-secondary' }
                        },
                        callback: function (result) {
                            if (result) {
                                if (target === '_blank') {
                                    window.open(url.href, '_blank');
                                } else {
                                    window.location.href = url.href;
                                }
                            }
                        }
                    });
                } else if (window.Swal) {
                    Swal.fire({
                        title: 'Salir del sitio',
                        html: `Va a salir del sitio. ¿Desea continuar hacia: <strong>${url.href}</strong>?`,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Continuar',
                        cancelButtonText: 'Cancelar',
                        reverseButtons: true,
                        allowOutsideClick: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            if (target === '_blank') {
                                window.open(url.href, '_blank');
                            } else {
                                window.location.href = url.href;
                            }
                        }
                    });
                } else {
                    // Fallback nativo
                    if (confirm(message)) {
                        if (target === '_blank') {
                            window.open(url.href, '_blank');
                        } else {
                            window.location.href = url.href;
                        }
                    }
                }
            }
        }, true);
    }

}